import { COLORS } from './themeConstants';

/**
 * Utility function to get all colors from the theme
 * @returns All color definitions from the theme
 */
export const getAllColors = () => {
  return COLORS;
};

/**
 * Get a specific color by path
 * @param path - Dot notation path to the color (e.g., 'primary.main', 'text.primary')
 * @returns The color value or undefined if not found
 */
export const getColorByPath = (path: string): string | undefined => {
  const parts = path.split('.');
  let current: any = COLORS;

  for (const part of parts) {
    if (current && typeof current === 'object' && part in current) {
      current = current[part];
    } else {
      return undefined;
    }
  }

  return typeof current === 'string' ? current : undefined;
};

/**
 * Get all color paths in dot notation
 * @returns Array of all color paths
 */
export const getAllColorPaths = (): string[] => {
  const paths: string[] = [];

  const traverse = (obj: any, currentPath: string = '') => {
    for (const key in obj) {
      const newPath = currentPath ? `${currentPath}.${key}` : key;

      if (typeof obj[key] === 'string') {
        paths.push(newPath);
      } else if (typeof obj[key] === 'object') {
        traverse(obj[key], newPath);
      }
    }
  };

  traverse(COLORS);
  return paths;
};

// Export all colors directly for convenience
export const {
  primary,
  secondary,
  text,
  background,
  border,
  error,
  success,
  warning,
  info,
} = COLORS;
